<div id="todo" class="page-layout carded left-sidebar inner-scroll">

    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="user-main-sidebar" position="left" lockedOpen="gt-md">

    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CENTER -->
    <div class="center">

        <div class="content-card">
            <!-- CONTENT -->
            <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                <div class="content p-24">
                    <ngx-datatable
                            class="material"
                            [rows]="rows"
                            [loadingIndicator]="loadingIndicator"
                            [columnMode]="'force'"
                            [headerHeight]="48"
                            [footerHeight]="56"
                            [rowHeight]="'auto'"
                            [scrollbarH]="true"
                            [reorderable]="reorderable"
                            [selectionType]="'checkbox'"
                            [limit]="10">

                        <ngx-datatable-column [width]="48"
                                              [canAutoResize]="false"
                                              [sortable]="false">
                            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
                                         let-selectFn="selectFn">
                            </ng-template>

                            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
                                         let-onCheckboxChangeFn="onCheckboxChangeFn">

                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-column name="{{'Card number'|translate}}" prop="cardNumber"></ngx-datatable-column>

                        <ngx-datatable-column name="{{'Username'|translate}}" prop="username"></ngx-datatable-column>

                        <ngx-datatable-column name="{{'E-mail'|translate}}" prop="email"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Phone'|translate}}" prop="phone"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'First name'|translate}}" prop="firstName"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Last name'|translate}}" prop="lastName"></ngx-datatable-column>
                        <ngx-datatable-column name="{{'Actions'|translate}}" sortable="false" prop="id">
                            <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

                                <a routerLink="/users/edit/{{row.id}}">{{'Edit'|translate}}</a>

                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </div>
</div>